import React, { Component } from "react";

class CurrentTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: new Date().toLocaleString("en-US", {
        timeZone: process.env.REACT_APP_PROJECT_TIMEZONE
      })
    };
  }
  componentDidMount() {
    this.intervalID = setInterval(() => this.tick(), 1000);
  }
  componentWillUnmount() {
    clearInterval(this.intervalID);
  }
  tick() {
    this.setState({
      time: new Date().toLocaleString("en-US", {
        timeZone: process.env.REACT_APP_PROJECT_TIMEZONE
      })
    });
  }
  render() {
    return (
      <p className="App-clock">
        It is currently {this.state.time} @ Gerlach, Nevada
      </p>
    );
  }
}

export default CurrentTime;
